import { Link } from 'react-router-dom';
import { VsjMapSection } from './VsjMapSection';
import './valor-san-juan.css';

export function ValorSanJuanPublicPage(): JSX.Element {
  return (
    <div className="vsj-page vsj-page--map-home">
      <header className="vsj-header">
        <Link to="/p/valor-san-juan" className="vsj-brand" style={{ textDecoration: 'none' }}>
          <div className="vsj-brand-icon" aria-hidden="true">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path
                d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                stroke="#fff"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9 22V12h6v10"
                stroke="#fff"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          Valor San Juan
        </Link>
        <nav className="vsj-nav" aria-label="Navegación principal">
          <Link to="/p/valor-san-juan/asistente" className="vsj-nav-link vsj-nav-link--cta">
            Consultar valor
          </Link>
        </nav>
      </header>
      <VsjMapSection />
    </div>
  );
}
